import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function DrawLotsPage() {
  const navigate = useNavigate();
  const [participants, setParticipants] = useState([
    { id: 1, name: "", result: "" },
    { id: 2, name: "", result: "" },
    { id: 3, name: "", result: "" }
  ]);

  const [gameStarted, setGameStarted] = useState(false);
  const [shuffledData, setShuffledData] = useState([]);
  const [revealedIdx, setRevealedIdx] = useState([]);

  const column = {
    display: 'flex', flexDirection: 'column', gap: '10px',
    maxHeight: participants.length >= 6 ? '300px' : 'none',
    overflowY: participants.length >= 6 ? 'auto' : 'visible',
    paddingRight: participants.length >= 6 ? '4px' : '0',
  };

  const prepareGame = () => {
    const names = participants.map((p, i) => p.name || `팀원 ${i + 1}`);
    const results = participants.map((p, i) => p.result || `결과 ${i + 1}`);
    const shuffled = [...results].sort(() => Math.random() - 0.5);
    const readyData = names.map((name, idx) => ({ name, value: shuffled[idx] }));
    setShuffledData(readyData);
    setRevealedIdx([]);
    setGameStarted(true);
  };

  const handleReveal = (index) => {
    if (revealedIdx.includes(index)) return;
    setRevealedIdx([...revealedIdx, index]);
  };

  const handleFullReset = () => {
    setParticipants([
      { id: 1, name: "", result: "" },
      { id: 2, name: "", result: "" },
      { id: 3, name: "", result: "" }
    ]);
    setGameStarted(false);
    setShuffledData([]);
    setRevealedIdx([]);
  };

  return (
    <div style={containerStyle}>
      <button onClick={() => navigate(-1)} style={backBtn}>← 이전으로</button>
      <h2 style={{textAlign: 'center', marginBottom: '30px', fontWeight: '800'}}>🎁 클릭! 제비뽑기</h2>

      {!gameStarted ? (
        <>
          <div style={inputGrid}>
            <div style={column}>
              <label style={labelStyle}>참여자 이름</label>
              {participants.map((p, idx) => (
                <input key={`name-${idx}`} style={inputStyle} placeholder={`팀원 ${idx + 1}`}
                  value={p.name} onChange={(e) => {
                    const updated = [...participants];
                    updated[idx].name = e.target.value;
                    setParticipants(updated);
                  }}
                />
              ))}
            </div>
            <div style={column}>
              <label style={labelStyle}>항목/결과</label>
              {participants.map((p, idx) => (
                <input key={`res-${idx}`} style={inputStyle} placeholder={`결과 ${idx + 1}`}
                  value={p.result} onChange={(e) => {
                    const updated = [...participants];
                    updated[idx].result = e.target.value;
                    setParticipants(updated);
                  }}
                />
              ))}
            </div>
          </div>
          <div style={btnGroup}>
            <button onClick={() => setParticipants([...participants, {id: Date.now(), name: "", result: ""}])} style={utilBtn}>인원 +</button>
            <button onClick={() => participants.length > 2 && setParticipants(participants.slice(0, -1))} style={utilBtn}>인원 -</button>
            <button onClick={prepareGame} style={startBtn}>제비 만들기!</button>
            <button onClick={handleFullReset} style={utilBtn}>초기화</button>
          </div>
        </>
      ) : (
        <div style={gameBoard}>
          <p style={{textAlign: 'center', color: '#666', marginBottom: '20px'}}>이름을 클릭해서 결과를 확인하세요!</p>
          <div style={cardGrid}>
            {shuffledData.map((data, idx) => (
              <div
                key={idx}
                onClick={() => handleReveal(idx)}
                style={{
                  ...cardStyle,
                  backgroundColor: revealedIdx.includes(idx) ? '#F3F4F6' : '#fff',
                  borderColor: revealedIdx.includes(idx) ? '#ddd' : '#4F46E5',
                }}
              >
                <div style={cardName}>{data.name}</div>
                {revealedIdx.includes(idx) ? (
                  <div style={cardValue}>{data.value}</div>
                ) : (
                  <div style={tapText}>터치하여 확인</div>
                )}
              </div>
            ))}
          </div>
          <div style={{display: 'flex', gap: '10px', marginTop: '30px'}}>
            <button onClick={() => setGameStarted(false)} style={resetBtn}>수정하기</button>
            <button onClick={handleFullReset} style={{...resetBtn, background: '#fff', color: '#000', border: '1px solid #ddd'}}>전체 초기화</button>
          </div>
        </div>
      )}
    </div>
  );
}

const containerStyle = {
  maxWidth: '700px', margin: '0 auto', padding: '60px 20px 80px',
  minHeight: '100vh', boxSizing: 'border-box',
  fontFamily: 'Pretendard, sans-serif', position: 'relative'
};

const backBtn = {
  position: 'absolute', top: '20px', left: '20px',
  padding: '8px 16px', background: '#fff',
  border: '1px solid #E5E7EB', borderRadius: '16px',
  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
  cursor: 'pointer', fontWeight: '600'
};

const inputGrid = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '30px' };
const labelStyle = { fontSize: '14px', fontWeight: 'bold', color: '#666' };
const inputStyle = { padding: '12px', borderRadius: '10px', border: '1px solid #ddd', textAlign: 'center' };
const btnGroup = { display: 'grid', gridTemplateColumns: '1fr 1fr 2fr 1fr', gap: '10px' };
const startBtn = { padding: '16px', background: '#4F46E5', color: '#fff', border: 'none', borderRadius: '12px', fontWeight: 'bold', cursor: 'pointer' };
const utilBtn = { padding: '16px', background: '#fff', border: '1px solid #ddd', borderRadius: '12px', cursor: 'pointer', fontWeight: '600' };
const gameBoard = { padding: '20px', background: '#F9FAFB', borderRadius: '24px', border: '1px solid #E5E7EB' };
const cardGrid = { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', gap: '15px' };
const cardStyle = {
  padding: '25px 15px', borderRadius: '18px', border: '2px solid', textAlign: 'center',
  cursor: 'pointer', transition: 'all 0.2s ease', display: 'flex', flexDirection: 'column', gap: '10px'
};
const cardName = { fontSize: '16px', fontWeight: 'bold', color: '#444' };
const cardValue = { fontSize: '20px', fontWeight: '800', color: '#E11D48' };
const tapText = { fontSize: '12px', color: '#4F46E5', fontWeight: '600' };
const resetBtn = { flex: 1, padding: '15px', background: '#000', color: '#fff', border: 'none', borderRadius: '12px', cursor: 'pointer', fontWeight: 'bold' };

export default DrawLotsPage;